import { emailRegexp } from 'javascripts/common/regexp'
import { selectors, setDay } from '../../common/birthday'

function setBirthdayListeners() {
  selectors.forEach((item) => {
    const targetElement = document.querySelector(item)
    if (!targetElement) return
    targetElement.removeEventListener('change', targetElement._birthdayChangeHandler)
    targetElement._birthdayChangeHandler = () => {
      const year = document.querySelector(selectors[0])?.value
      setDay(
        year,
        document.querySelector(selectors[0]).value,
        document.querySelector(selectors[1]).value,
        document.querySelector(selectors[2]).value,
        selectors[1],
        selectors[2],
        '日'
      )
    }
    targetElement.addEventListener('change', targetElement._birthdayChangeHandler)
  })
}

function setBirthdayInitialValues() {
  const year = document.querySelector(selectors[0])?.value
  setDay(
    year,
    document.querySelector(selectors[0]).value,
    document.querySelector(selectors[1]).value,
    document.querySelector(selectors[2]).value,
    selectors[1],
    selectors[2],
    '日'
  )
}

function initialize() {
  setBirthdayInitialValues()
  setBirthdayListeners()

  const $overseas = $('.js-overseas')
  const $prefecture = $('.js-prefecture_id')
  const onPrefectureChanged = () => $prefecture.prop('disabled', $overseas.prop('checked'))

  $overseas.on('click', onPrefectureChanged)
  onPrefectureChanged()

  if (document.body.classList.contains('action--new')) {
    let dirty = false
    $('form').on('change', () => { dirty = true })
    $('form').on('submit', () => { $(window).off('beforeunload') })

    $(window).on('beforeunload', (e) => {
      if (dirty) {
        const confirmationMessage = '入力された内容は破棄されます。'
        e.returnValue = confirmationMessage
        return confirmationMessage
      }
    })
  }

  // メールアドレスのバリデーション
  const emailInputElement = $('#user_registration_form_email')
  emailInputElement.on('input', () => {
    const email = emailInputElement.val()
    const emailElement = $('.-email').parent()
    if (!emailRegexp.test(email)) {
      if (emailElement.children().hasClass('tech-form-item-error')) return false
      const notMatchEmailFormatMessage = $('<p>', { class: 'tech-form-item-error', text: 'メールアドレスの形式が正しくありません' })
      emailElement.append(notMatchEmailFormatMessage)
    } else {
      emailElement.find('.tech-form-item-error').remove()
    }
  })
}

// 最初のページロードの際に初期化する
window.addEventListener('turbo:load', initialize)
// バリデーション等でページがレンダリングされた後にも初期化する
window.addEventListener('turbo:render', initialize)
